import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerWorkflowMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('workflow', locale)
}
